import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import '../../BaseStyle/Style.css'
import './Layout.css'

import Header from '@components/Common/Header/Header'
import Footer from '@components/Common/Footer/Footer'
import { init as clientJs } from './../../../client-js/index'

const Layout = ({ children }) => {
  useEffect(() => clientJs())

  return (
    <>
      <div className='page-wrap'>
        <Header />
        <main className='inner-wrap'>{children}</main>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
